import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { BlueButton } from '../BlueButton';

function SearchFormButton({ children, ...props }) {
  const { submitForm, isSubmitting } = useFormikContext();

  return (
    <BlueButton
      onClick={(e) => {
        submitForm();
      }}
      disabled={isSubmitting}
      {...props}
    >
      {children}
    </BlueButton>
  );
}

SearchFormButton.propTypes = {};

export default SearchFormButton;
